var map = {
	"./GA4.svg": "e539",
	"./ajio.svg": "0f1d",
	"./amazon_retail.svg": "a8b0",
	"./amazon_retail_uae.svg": "5e23",
	"./blinkit.svg": "7b63",
	"./boat.svg": "1ec5",
	"./carrefour.svg": "f6ee",
	"./croma.svg": "9cec",
	"./dmart.svg": "ebec",
	"./flipkart.svg": "2e3d",
	"./flipkart_grocery.svg": "1ebd",
	"./jiomart.svg": "f6d9",
	"./myntra.svg": "9f9b",
	"./namshi.svg": "fa42",
	"./noon.svg": "019b",
	"./nykaa_fashion.svg": "ea8f",
	"./ozone.svg": "02f7",
	"./reliance_digital.svg": "19eb",
	"./swiggy.svg": "b907",
	"./tata_cliq.svg": "f415a",
	"./vijaysales.svg": "6e08",
	"./zepto.svg": "449a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "331a";